import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors} from '@angular/forms';
import { comedorModulo } from '../../diccionarios/comedorModulo';
import { ComedorService } from '../../services/comedor.services';
import { UtilsService } from '../../../../shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-mantener-precios',
  templateUrl: './mantener-precios.component.html',
  styleUrls: ['./mantener-precios.component.css']
})

export class MantenerPreciosComponent implements OnInit {
  public DAT_TITULOS = comedorModulo.titulos.precios;
  public DAT_AG_GRID = comedorModulo.agGrid;

  public titleModal  : string;
  public loading     : boolean = false;
  public isCreate    : boolean = false;

  public frameworkComponents: any;
  public columnDefs  : any[] = [];
  public rowData     : any[] = [];
  public gridApi     : any;
  public gridColumnApi: any;

  public cbxComida    : Array<{ clave: string, valor: string }> = [];
  public cbxLocalidad : any[] = [];
  public cbxTipoEmpleado : any[] = [];

  public formulario = new FormGroup({
    localidad   : new FormControl('', [Validators.required]),
    precio      : new FormControl('', [Validators.required, Validators.min(0)]),
    tipoComida  : new FormControl('', [Validators.required]),
    tipoEmpleado: new FormControl('', [Validators.required]),
    valorFabril : new FormControl('', [Validators.required, Validators.min(0), Validators.max(100), Validators.pattern('^[0-9]*$')]),
    valorCopago : new FormControl('', [Validators.required, Validators.min(0), Validators.max(100), Validators.pattern('^[0-9]*$')]),
    totalValor  : new FormControl('', [Validators.required, Validators.max(100), Validators.pattern('^[0-9]*$')]),
    }, 
    { validators: this.sumValidator } // Validacion Global para la suma
  );

  constructor(
    private comedorServices : ComedorService,
    private utilServices    : UtilsService,
  ) { }

  // Getters
  get valorFabril() {
    return this.formulario.get('valorFabril');
  }

  get valorCopago() {
    return this.formulario.get('valorCopago');
  }

  ngOnInit(): void {
    this.inicializaCombos();
    this.gridComponent();
    this.listar();

    // Suscribirse a cambios
    this.formulario.get('valorFabril')?.valueChanges.subscribe(() => {
      this.updateTotal();
    });

    this.formulario.get('valorCopago')?.valueChanges.subscribe(() => {
      this.updateTotal();
    });

  }

  gridComponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [
      { filter: true, resizable: true, field: 'dscaLocalidad', headerName: 'Localidad'},
      { filter: true, resizable: true, field: 'tipoComida'},
      { filter: true, resizable: true, field: 'tipoEmpleado'},
      { filter: true, resizable: true, width: 100, field: 'precio', valueFormatter: "'$' + value.toLocaleString()",},
      { filter: true, resizable: true, width: 150, field: 'valorCopago', valueFormatter: "value.toLocaleString() + ' %' ",},
      { filter: true, resizable: true, width: 150, field: 'valorFabril', valueFormatter: "value.toLocaleString() + ' %' ",},
      { cellRenderer: 'buttonRenderer', headerName: 'EDITAR', 
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: 'Editar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-edit'
        },
      },
      { cellRenderer: 'buttonRenderer', headerName: 'ELIMINAR',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-trash'
        },
      }
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar(){
    this.comedorServices.getComidasPrecio().subscribe((res) => {
      if(res.length > 0){
        this.rowData = res;
      }else{
        this.utilServices.mensajeOKToast("No se encontraron regitros", 3000);
        this.rowData =[];
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.DAT_TITULOS.tituloAgregar;
    
    this.formulario.reset();
    this.openModal();
  }

  editar({rowData}){
    this.isCreate   = false;
    this.titleModal = this.DAT_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.formulario.get('localidad')?.disable({ onlySelf: true });
    this.formulario.get('tipoComida')?.disable({ onlySelf: true });
    this.openModal();
  }

  eliminar({rowData}){
    this.loading = true;
    console.log('Eliminar => ', rowData);

    this.utilServices.confirmarSincronoPromesa({
        title : comedorModulo.mensajes.eliminar,
        text  : this.DAT_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.comedorServices.deleteComidasPrecios(rowData),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
      });

      this.loading = false;
  }

  saveForm() {
    if (this.formulario.invalid) return;

    this.loading = true;
    let mensajeP = this.isCreate ? comedorModulo.mensajes.guardar : comedorModulo.mensajes.actualizar;
    const precio = this.formulario.getRawValue();

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.comedorServices.createComidasPrecios(precio) : this.comedorServices.updateComidasPrecios(precio),
      })
      .then(() => {
        this.listar();
        this.closeModal();
      })
      .catch(() => {
      });

      this.loading = false;
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  // Actualiza totalValor
  updateTotal(): void {
    const number1 = +this.formulario.get('valorFabril')?.value;
    const number2 = +this.formulario.get('valorCopago')?.value;
    const total = number1 + number2;

    this.formulario.get('totalValor')?.setValue(total, { emitEvent: false });
  }

  // Validador personalizado p/comprobar si suma = 100
  sumValidator(formulario: FormGroup): ValidationErrors | null {
    const number1 = +formulario.get('valorFabril')?.value;
    const number2 = +formulario.get('valorCopago')?.value;
    
    // Retorna el error si la suma no es 100
    if ((number1 + number2) !== 100) {
      return { sumNotEqual: true }; 
    }
    return null;
  }


  inicializaCombos(){
    this.loading = true;

    this.comedorServices.getComidas().subscribe((res) => {
      for (let i = 0; i < res.length; i++) {
        this.cbxComida.push({clave: res[i], valor: res[i]});
      }
    }, (err) => { 
      console.log(err.message); 
      this.cbxComida =[];
    });

    this.cbxLocalidad = [];
    this.comedorServices.getComedoresLocalidad().subscribe((res) => {
      if(res.length > 0){
        this.cbxLocalidad = Array.from(
          new Map(res.map(
            ({localidad, dscaLocalidad }) => [localidad + dscaLocalidad, {localidad, dscaLocalidad}]
          )).values());

          console.log(this.cbxLocalidad);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron localidades de comedores", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
      this.cbxLocalidad = []

    });

    this.cbxTipoEmpleado.push({clave: 'OPERATIVO', valor: 'OPERATIVO'}); //1 
    this.cbxTipoEmpleado.push({clave: 'ADMINISTRATIVO', valor: 'ADMINISTRATIVO'}); //2

    this.loading = false;
  }


}
